// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".embed-view .prism-component[data-v-44962836]{margin-top:25px}", ""]);
// Exports
module.exports = exports;
